import React, { useEffect, useState } from 'react';

import "./Persona.css";
import { PersonaColumnList } from './PersonaConstants';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

function Persona(props) {
    const { personaId } = props;

    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [selectedPersona, setSelectedPersona] = useState();

    const moduleData = useSelector((state) => state.persona);

    useEffect(() => {
        if (personaId) {
            const selPersona = moduleData?.personaList?.find(pl => pl.id === personaId);
            setSelectedPersona(selPersona);
        }
    }, [personaId]);

    const renderItem = (pcl) => {
        return (
            <div className='item' key={`info-item-${pcl.dbname}`}>
                <div className='title'>{t(pcl.label)}:</div>
                <div className='content'>{selectedPersona[pcl.dbname]}</div>
            </div>
        )
    }

    return (
        <div
            className="modal"
            id={`persona_detail_modal`}
            data-bs-backdrop="static"
            tabIndex="-1"
            aria-hidden="true"
        >
            <div className="modal-dialog  modal-xl modal-administrator" >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="backDropModalTitle">{t("persona")}: {selectedPersona?.nombre}</h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className='module-info-container'>
                            <div className='module-info-data' >
                                {
                                    selectedPersona && PersonaColumnList().filter(pcl => pcl.form === true).map(pcl => (renderItem(pcl)))
                                }
                            </div>
                            <div className='persona-info'>
                                info no imprlementado todavía
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Persona;